export const immunologic = (() => {
    const placeHolderText = 'No Allergic reactions or recurrent infections.  '

    return placeHolderText
})